<template>
    <div>
        <b-row>
            <b-col align-h="center" cols="12" md="12" v-if="!this.client">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectClient"
                />
            </b-col>
            <b-col cols="12" md="12">
                <app-form-text-input
                    label="Documento"
                    id="document"
                    :required="true"
                    :hasError="$v.theRestrictedVisitor.document.$error"
                    errorMessage="Debe escribir el documento del usuario restringido"
                    @input="$v.theRestrictedVisitor.document.$touch()"
                    v-model="theRestrictedVisitor.document"
                />
            </b-col>
            <b-col cols="12" md="12">
                <app-form-text-input
                    label="Nombre"
                    id="name"
                    :required="true"
                    :hasError="$v.theRestrictedVisitor.name.$error"
                    errorMessage="Debe escribir el nombre del usuario restringido"
                    @input="$v.theRestrictedVisitor.name.$touch()"
                    v-model="theRestrictedVisitor.name"
                />
            </b-col>
            <b-col cols="12" md="12">
                <app-form-textarea-input
                    label="Instrucciones"
                    id="instructions"
                    v-model="theRestrictedVisitor.instructions"
                    :required="true"
                    :hasError="$v.theRestrictedVisitor.instructions.$error"
                    errorMessage="Debe escribir las instrucciones de la restricción"
                    @input="$v.theRestrictedVisitor.instructions.$touch()"
                />
            </b-col>
            <b-col v-show="!myRestrictedVisitor">
                <b-card
                    title="Foto del usuario restringido"
                    tag="article"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <b-form-file
                            v-model="theRestrictedVisitor.file"
                            :state="Boolean(theRestrictedVisitor.file)"
                            placeholder="Seleccione imagen del usuario restringido"
                            accept=".jpg, .jpeg, .png"
                            ref="fileinput"
                        ></b-form-file>
                        <div v-if="theRestrictedVisitor.file" class="mt-3">
                            Archivo seleccionado:
                            {{
                                theRestrictedVisitor.file &&
                                    theRestrictedVisitor.file.name
                            }}
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import restrictedVisitorsRepository from "../../../../../repositories/restrictedVisitors.repository.js";
import UploadOrTakePhoto from "../../../../UI/Controls/Photos/UploadOrTakePhoto.vue";
import Autocomplete from "../../../../UI/Controls/AutocompleteV2/Autocomplete.vue";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
    components: {
        appUploadOrTakePhoto: UploadOrTakePhoto,
        appAutocomplete: Autocomplete
    },

    props: {
        onSave: {
            type: Function
        },
        myRestrictedVisitor: {
            default: null
        }
    },

    data() {
        return {
            theRestrictedVisitor: {
                clientId: "",
                registeredById: "",
                document: "",
                name: "",
                instructions: "",
                file: ""
            },
            selectClient: ""
        };
    },

    validations: {
        theRestrictedVisitor: {
            document: { required },
            name: { required },
            instructions: { required }
        }
    },

    watch: {
        myRestrictedVisitor(val) {
            this.fillForm();
        },
        selectClient(val) {
            if (!val) {
                this.theRestrictedVisitor.clientId = "";
                this.selectClient = "";
            } else {
                this.theRestrictedVisitor.clientId = val.id;
            }
        }
    },

    computed: {
        ...mapGetters({
            clients: "clients"
        })
    },
    methods: {
        saveRestrictedVisitor() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const formData = new FormData();

            formData.append(
                "clientId",
                this.client
                    ? this.client.id
                    : this.theRestrictedVisitor.clientId
            );
            formData.append("registeredById", this.user.id);
            formData.append("document", this.theRestrictedVisitor.document);
            formData.append("name", this.theRestrictedVisitor.name);
            formData.append(
                "instructions",
                this.theRestrictedVisitor.instructions
            );

            if (this.theRestrictedVisitor.file) {
                formData.append("file", this.theRestrictedVisitor.file);
            }

            const rvr = { ...restrictedVisitorsRepository };
            rvr.saveRestrictedVisitor(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Ocurrió un error al guardar el usuario restringido"
                    );
                });
        },
        updateRestrictedVisitor(id) {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const rvr = { ...restrictedVisitorsRepository };
            rvr.updateRestrictedVisitor(
                this.theRestrictedVisitor,
                this.myRestrictedVisitor.id
            )
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanFields();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Ocurrió un error al actualizar el usuario restringido"
                    );
                });
        },
        saveOrUpdate() {
            if (!!this.myRestrictedVisitor) {
                this.updateRestrictedVisitor();
            } else {
                this.saveRestrictedVisitor();
            }
        },
        fillForm() {
            if (Object.keys(this.myRestrictedVisitor).length !== 0) {
                this.selectClient = this.myRestrictedVisitor.client;
                this.theRestrictedVisitor.clientId = this.myRestrictedVisitor.client_id;
                this.theRestrictedVisitor.document = this.myRestrictedVisitor.document;
                this.theRestrictedVisitor.name = this.myRestrictedVisitor.name;
                this.theRestrictedVisitor.instructions = this.myRestrictedVisitor.instructions;
            } else {
                this.cleanFields();
            }
        },
        cleanFields() {
            this.selectClient = "";
            this.$refs.fileinput.reset();
            this.theRestrictedVisitor.file = null;
            Object.keys(this.theRestrictedVisitor).map(
                key => (this.theRestrictedVisitor[key] = "")
            );
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        initialize() {}
    },
    created() {
        this.initialize();
        this.$bus.$on("restricted-visitor-form.save", this.saveOrUpdate);
        this.$bus.$on("restricted-visitor-form.clean", this.cleanFields);
    },
    beforeDestroy() {
        this.$bus.$off("restricted-visitor-form.save");
    }
};
</script>

<style>
.custom-file-input:lang(es) ~ .custom-file-label::after {
    content: "Buscar";
}
</style>
